/**
 * BasicInfoSection.tsx
 * 顧客名(インライン編集), 予約番号
 */
import React from 'react';
import { SectionProps } from '../types';
import SectionHeader from '../shared/SectionHeader';
import FieldDisplay from '../shared/FieldDisplay';
import InlineEditField from '../shared/InlineEditField';
import SquarePaymentInfo from './SquarePaymentInfo';

export default function BasicInfoSection({
  data,
  onChange,
  disabled,
  isNew,
  onOpenEdit,
}: SectionProps) {
  return (
    <>
      <SectionHeader title="基本情報" />
      <InlineEditField
        label="予約名"
        field="customer_name"
        value={data.customer_name}
        onChange={onChange}
        disabled={disabled}
      />
      <FieldDisplay
        label="予約コード"
        value={data.contact_code}
        onClick={
          isNew
            ? () => onOpenEdit?.('contact_code', '予約コード')
            : undefined
        }
      />
      <SquarePaymentInfo contactCode={data.contact_code} />
    </>
  );
}
